import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { of } from "rxjs";
import { environment } from "src/environments/environment";
@Injectable()
export class SharedService {
  // sharedUrl='http://localhost:4000/mentorship-api/meetings/'
  sharedUrl = `${environment.baseUrl}meetings/`;
  constructor(private httpClient: HttpClient) {}
  public setMeeting(meetingDetails) {
    return this.httpClient.post(this.sharedUrl, meetingDetails);
  }
  public scheduleGroupTask(meetingDetails){
    return this.httpClient.post(`${this.sharedUrl}/schedule-with-groups`,meetingDetails);
  }
  public getScheduledMeetings(scholarId, mentorId, filter) {
    if (scholarId == "" || mentorId == "") return of([]);
    return this.httpClient.get(
      this.sharedUrl  +
        scholarId +
        "/" +
        mentorId +
        "?filter=" +
        filter
    );
  }
  public setMentorNotes(details) {
    return this.httpClient.post(
      this.sharedUrl + "mentor/notes",
      details
    );
  }
  public setScholarNotes(details) {
    return this.httpClient.post(
      this.sharedUrl + "meetings/scholar/notes",
      details
    );
  }
  public getUnCommentedMeetings(scholarId, mentorId) {
    if (scholarId == "" || mentorId == "") return of([]);
    return this.httpClient.get(
      this.sharedUrl + "uncommented/" + scholarId + "/" + mentorId
    );
  }
  // public getMentorshipDetails(scholarId, mentorId) {
  //     if (scholarId == '' || mentorId == '') return of(null)
  //     return this.httpClient.get(this.sharedUrl + 'meetings/mentorship/details/' + scholarId + "/" + mentorId)

  // }
  public getMentorshipDetails(scholarId) {
    if (scholarId == "") return of(null);
    return this.httpClient.get(
      this.sharedUrl + "mentorship/details/" + scholarId
    );
  }
  getMentorScholarDetails(mentorId) {
    if (mentorId == "") return of(null);
    return this.httpClient.get(
      this.sharedUrl + "mentorScholar/details/" + mentorId
    );
  }
  getScheduledMeetingList(mentorId: string) {
    if (mentorId == "") return of(null);
    return this.httpClient.get(this.sharedUrl  + mentorId);
  }

  scheduleTask(taskDetails) {
    return this.httpClient.patch(this.sharedUrl, taskDetails);
  }
  getMeetingNotes(meetingId: string) {
    if (meetingId == "") return of(null);
    return this.httpClient.get(
      this.sharedUrl + "notes/get-notes/" + meetingId
    );
  }
  getMeetingDocuments(meetingId) {
    if (meetingId == "") return of(null);
    return this.httpClient.get(
      this.sharedUrl + "documents/get-documents/" + meetingId
    );
  }
  uploadFiles(details) {
    return this.httpClient.post(
      this.sharedUrl + "mentor/files",
      details
    );
  }
  getMeetingDetails(meetingId) {
    if (meetingId == "") return of(null);
    return this.httpClient.get(
      this.sharedUrl + "task/taskDetails/" + meetingId
    );
  }
  updateTask(taskDetails) {
    return this.httpClient.patch(
      this.sharedUrl + "updateTask",
      taskDetails
    );
  }
  deleteTask(mentorId,taskId){
    return this.httpClient.delete(`${this.sharedUrl}deleteTask/${mentorId}/${taskId}`);
  }
  initiatePasswordReset(email: string,type:string) {
    return this.httpClient.post(`${this.sharedUrl}reset-password`, { email, type});
  }

  updatePassword(token: string, newPassword: string) {
    return this.httpClient.patch(`${this.sharedUrl}update-password`, {token, newPassword });

  }
}
